import { memo } from 'react';

import { CrehanaNextSeo } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { getImgxUrl } from '@crehana/ui';
import { useRouter } from 'next/router';

import type { TCourse } from './types';

type SEOProps = {
  course: TCourse;
};

const SEO: React.FC<SEOProps> = ({ course }) => {
  const { query } = useRouter();
  const metaTitle = `${course.metaTitle || course.title}`;
  const path = `/org/${query.orgSlug}/content/${query.contentSlug}/`;

  return (
    <CrehanaNextSeo
      path={path}
      hasCountryCode={false}
      noindex
      title={metaTitle}
      titleTemplate="%s | Curso | Crehana"
      description={course.metaDescription}
      openGraph={{
        type: 'crehana:product',
        site_name: 'Crehana',
        ...(course.promoImage
          ? {
              images: [
                {
                  url: getImgxUrl(course.promoImage, {
                    w: 1200,
                    h: 630,
                    q: 50,
                  }),
                  alt: 'Crehana',
                },
              ],
            }
          : undefined),
      }}
      twitter={{
        cardType: 'summary',
      }}
    />
  );
};

export default memo(SEO);
